/* global ahoy */
import React, { useState, useEffect } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import parse from 'html-react-parser';

const DutyRequestTour = ({ startImmediately, groupId }) => {
  useEffect(() => document.addEventListener('reacttour.duty_request', handleRun), []);

  const [run, setRun] = useState(startImmediately);

  const handleRun = () => {
    setRun(!run);
    ahoy.track('[Extra Shift Virtual Tour] Manually started', {
      group_id: groupId || null
    });
  };

  const handleJoyrideCallback = data => {
    const { status } = data;

    if (status == STATUS.FINISHED) {
      ahoy.track('[Extra Shift Virtual Tour] Finished', {
        group_id: groupId || null
      });
      setRun(false);
    }
    if (status == STATUS.SKIPPED) {
      ahoy.track('[Extra Shift Virtual Tour] Skipped', {
        group_id: groupId || null,
        step_index: data.index
      });
      setRun(false);
    }
  };

  const steps = [
    {
      target: '#content',
      content: parse(I18n.t('tours.duty_request.welcome')),
      placement: 'center'
    },
    {
      target: '.dutyFunctionSelector',
      content: parse(I18n.t('tours.duty_request.duty_function_selector')),
      placement: 'auto'
    },
    {
      target: '.periodSelector',
      content: parse(I18n.t('tours.duty_request.period_selector')),
      placement: 'auto'
    },
    {
      target: '.groupSelector',
      content: I18n.t('tours.duty_request.group_selector'),
      placement: 'auto'
    },
    {
      target: '.availabilityCodeSelector',
      content: I18n.t('tours.duty_request.availability_code_selector'),
      placement: 'auto'
    },
    {
      target: '.resolutionMechanismSelector',
      content: parse(I18n.t('tours.duty_request.resolution_mechanism_selector')),
      placement: 'auto'
    },
    {
      target: '.overlappingRequestsTable',
      content: parse(I18n.t('tours.duty_request.overlapping_request_table')),
      placement: 'auto'
    },
    {
      target: '.filtersMenu',
      content: parse(I18n.t('tours.duty_request.filters')),
      placement: 'auto'
    },
    {
      target: '.filterAvailableOnly',
      content: I18n.t('tours.duty_request.available_only'),
      placement: 'auto'
    },
    {
      target: '#name',
      content: I18n.t('tours.duty_request.name'),
      placement: 'auto'
    },
    {
      target: '.skillsByName',
      content: I18n.t('tours.duty_request.skills'),
      placement: 'auto'
    },
    {
      target: '.availabilityCodesByName',
      content: I18n.t('tours.duty_request.availability_codes'),
      placement: 'auto'
    },
    {
      target: '.crewType',
      content: parse(I18n.t('tours.duty_request.crew_type')),
      placement: 'auto'
    },
    {
      target: '.memberOf',
      content: I18n.t('tours.duty_request.member_of'),
      placement: 'auto'
    },
    {
      target: '.candidateType',
      content: I18n.t('tours.duty_request.candidate_type'),
      placement: 'auto'
    },
    {
      target: '.contractStatistics',
      content: parse(I18n.t('tours.duty_request.contract_statistics')),
      placement: 'auto'
    },
    {
      target: '#new_filter_name',
      content: parse(I18n.t('tours.duty_request.search_name')),
      placement: 'auto'
    },
    {
      target: '.saveFilters',
      content: I18n.t('tours.duty_request.save_filters'),
      placement: 'auto'
    },
    {
      target: '.candidatesTable',
      content: parse(I18n.t('tours.duty_request.candidates_table')),
      placement: 'auto'
    },
    {
      target: '.saveDutyRequest',
      content: parse(I18n.t('tours.duty_request.save_duty_request')),
      placement: 'top'
    },
    {
      target: '.help-button',
      content: parse(I18n.t('tours.duty_request.help')),
      placement: 'bottom'
    }
  ];

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous={true}
      callback={handleJoyrideCallback}
      styles={{
        tooltipContainer: {
          textAlign: 'left'
        },
        options: {
          primaryColor: 'var(--bs-primary)'
        }
      }}
      showProgress={true}
      showSkipButton={true}
      scrollOffset={100}
    />
  );
};

export default DutyRequestTour;
